import Mock from 'mockjs'

// 设置延迟时间
Mock.setup({
  timeout: '200-600'
})

// 图书统计数据
Mock.mock('/api/book-statistics', 'get', {
  code: 200,
  message: 'success',
  data: {
    inventory: '@integer(50000, 100000)',
    turnoverRate: '@float(0.1, 0.9, 2, 2)',
    totalBooks: '@integer(10000, 50000)',
    activeMembers: '@integer(5000, 20000)'
  }
})

// 渠道销售占比数据
Mock.mock(/\/api\/channel-sales/, 'get', (options) => {
  const url = new URL('http://localhost' + options.url)
  const period = url.searchParams.get('period') || 'today'
  
  const mockData = {
    code: 200,
    message: 'success',
    data: {
      period: period,
      channels: [
        {
          channelId: '1',
          channelName: '第三方线上',
          salesAmount: 120000,
          percentage: 15,
          growth: 8.7
        },
        {
          channelId: '2',
          channelName: '自营平台',
          salesAmount: 100000,
          percentage: 50,
          growth: -5.2
        },
        {
          channelId: '3',
          channelName: '线下零售',
          salesAmount: 150000,
          percentage: 35,
          growth: 12.3
        },
      ]
    }
  }
  
  return Mock.mock(mockData);
})

// 销售大类占比数据
Mock.mock(/\/api\/sales-category/, 'get', (options) => {
  const url = new URL('http://localhost' + options.url)
  const period = url.searchParams.get('period') || 'today'
  
  const mockData = {
    code: 200,
    message: 'success',
    data: {
      period: period,
      categories: [
        {
          categoryId: '1',
          categoryName: '教材教辅',
          salesAmount: 200000,
          percentage: 35.2,
          growth: 8.5
        },
        {
          categoryId: '2',
          categoryName: '文学艺术',
          salesAmount: 120000,
          percentage: 22.8,
          growth: 12.3
        },
        {
          categoryId: '3',
          categoryName: '科技图书',
          salesAmount: 80000,
          percentage: 15.6,
          growth: 18.7
        },
        {
          categoryId: '4',
          categoryName: '少儿读物',
          salesAmount: 60000,
          percentage: 12.4,
          growth: 25.1
        },
        {
          categoryId: '5',
          categoryName: '社科人文',
          salesAmount: 40000,
          percentage: 8.8,
          growth: 5.2
        },
        {
          categoryId: '6',
          categoryName: '生活休闲',
          salesAmount: 25000,
          percentage: 5.2,
          growth: -2.3
        }
      ]
    }
  }
  
  return Mock.mock(mockData);
})

// 会员活跃趋势数据
Mock.mock('/api/member-trend', 'get', {
  code: 200,
  message: 'success',
  data: {
    'dates|30': ['@date("MM-dd")'],
    'values|30': ['@integer(1000, 8000)']
  }
})

// 今日码洋总览数据
Mock.mock('/api/today-sales', 'get', {
  code: 200,
  message: 'success',
  data: {
    totalAmount: '@integer(500000, 2000000)',
    growth: '@float(-10, 30, 2, 2)'
  }
})

// 湖南地图数据
Mock.mock('/api/hunan-map', 'get', {
  code: 200,
  message: 'success',
  data: {
    'regions|14': [{
      'regionId': '@id',
      'regionName': '@pick(["长沙市", "株洲市", "湘潭市", "衡阳市", "邵阳市", "岳阳市", "常德市", "张家界市", "益阳市", "郴州市", "永州市", "怀化市", "娄底市", "湘西州"])',
      'salesAmount': '@integer(50000, 500000)',
      'orderCount': '@integer(100, 2000)',
      'growth': '@float(-20, 50, 2, 2)',
      'coordinates': ['@float(108, 114, 6, 6)', '@float(24, 30, 6, 6)']
    }]
  }
})

// 教材征订统计数据
Mock.mock(/\/api\/textbook-statistics/, 'get', (options) => {
  const url = new URL('http://localhost' + options.url)
  const period = url.searchParams.get('period') || 'recent7days'
  const template = {
    code: 200,
    message: 'success',
    data: {
      period: period,
      totalOrders: '@integer(5000, 50000)',
      totalAmount2025: '@integer(1000000, 10000000)',
      autumnAmount25: '@integer(500000, 5000000)',
      'details|10-15': [{
        'schoolId': '@id',
        'schoolName': '@ctitle(5, 15)学校',
        'orderCount': '@integer(50, 500)',
        'orderAmount': '@integer(10000, 100000)',
        'status': '@pick(["已确认", "待审核", "已完成", "进行中"])'
      }]
    }
  }

  // 使用 Mock.mock 编译模板，确保返回的为真实随机数据而非字符串指令
  return Mock.mock(template)
})

// 订单数及码洋同比数据
Mock.mock('/api/order-comparison', 'get', {
  code: 200,
  message: 'success',
  data: {
    'dates|12': ['@date("MM月")'],
    'orders|12': [{
      'currentYear': '@integer(1000, 5000)',
      'lastYear': '@integer(800, 4500)'
    }],
    'amounts|12': [{
      'currentYear': '@integer(100000, 800000)',
      'lastYear': '@integer(80000, 700000)'
    }]
  }
})

// 各市州渠道对比数据
Mock.mock(/\/api\/city-channel-comparison/, 'get', (options) => {
  const url = new URL('http://localhost' + options.url)
  const period = url.searchParams.get('period') || 'today'
  
  // 生成城市数据
  const cities = []
  const cityNames = ["长沙市", "株洲市", "湘潭市", "衡阳市", "邵阳市", "岳阳市", "常德市", "张家界市", "益阳市", "郴州市", "永州市", "怀化市", "娄底市", "湘西州"]
  const channelNames = ["线上", "门店", "批发", "教育", "企业"]
  
  for (let i = 0; i < 14; i++) {
    const channelCount = Mock.Random.integer(3, 5)
    const selectedChannels = Mock.Random.shuffle(channelNames).slice(0, channelCount)
    
    // 生成百分比，确保总和为100%
    const percentages = []
    let remaining = 100
    for (let j = 0; j < channelCount - 1; j++) {
      const maxPercentage = Math.min(remaining - (channelCount - j - 1) * 5, remaining * 0.6)
      const minPercentage = Math.max(5, remaining - (channelCount - j - 1) * 50)
      const percentage = Mock.Random.float(minPercentage, maxPercentage, 2, 2)
      percentages.push(percentage)
      remaining -= percentage
    }
    percentages.push(parseFloat(remaining.toFixed(2)))
    
    const channels = selectedChannels.map((channelName, index) => ({
      channelName: channelName,
      salesAmount: Mock.Random.integer(10000, 200000),
      percentage: percentages[index]
    }))
    
    cities.push({
      cityId: Mock.Random.id(),
      cityName: cityNames[i],
      channels: channels,
      totalAmount: Mock.Random.integer(50000, 800000),
      growth: Mock.Random.float(-15, 35, 2, 2)
    })
  }
  
  return {
    code: 200,
    message: 'success',
    data: {
      period: period,
      cities: cities
    }
  }
})

console.log('Mock.js 数据模拟已启动')

export default Mock